export default {"src":"/_next/static/media/heart-outline.20048dfb.svg","height":17,"width":18,"blurWidth":0,"blurHeight":0};